/**
 * Core doc schema — mirror of `server/drang/core/schema.py` (design spec §8.1, §9.4).
 * Container names and builtin PropDefs must match byte for byte; `schema.test.ts` compares the JSON.
 */
export const SCHEMA_VERSION = 9;

export const C = {
  meta: "meta",
  tasks: "tasks",
  tree: "tree",
  edges: "edges",
  sequences: "sequences",
  groups: "groups",
  propDefs: "propDefs",
  dashboards: "dashboards",
  tracking: "tracking",
  planner: "planner",
  counters: "counters",
  reminders: "reminders",
  propsets: "propsets",
  automations: "automations",
  settings: "settings",
  entries: "entries",
} as const;

export type PropKind = "tag" | "enum" | "number" | "text" | "datetime" | "geo";
export type Level = "simple" | "standard" | "power";

export interface EnumValue {
  id: string;
  label: string;
  color: string | null;
}

export interface PropDef {
  id: string;
  name: string;
  kind: PropKind;
  spec: Record<string, unknown>;
  builtin: boolean;
  shownInQuickAdd: boolean;
  level: Level;
  bundleId?: string;
  bundleVersion?: string;
}

export type PropVal = boolean | number | string | string[] | { lat: number; lon: number; label?: string };

export interface Task {
  id: string;
  typeId: string;
  title: string;
  notes: string;
  createdAt: string;
  doneAt: string | null;
  archivedAt: string | null;
  doneBy?: string;
  orderedChildren: boolean;
  /** tree node id `"<counter>@<peer>"` (ADR 0003) */
  nodeId?: string;
  props: Record<string, PropVal>;
  attachments: Record<string, { name: string; mime: string; size: number; sha256: string }>;
}

export const BUILTIN_TASK_TYPES = ["task", "recurring", "note"] as const;

export function coreDocId(workspaceId: string): string {
  return `${workspaceId}:core`;
}

export function timelogDocId(workspaceId: string, yearMonth: string): string {
  return `${workspaceId}:timelog:${yearMonth}`;
}
